import { createSelector } from 'reselect'
import { selectIsKbsLoaded } from './selectIsKbsLoaded'
import { selectKnowledgeBases } from './index'

/**
 * Returns the count of knowledge bases that should count towards billing limits.
 * Excludes KBs that have completed migration to InstantDocs (migrationStatus === 'completed').
 * Returns null if KBs haven't been loaded yet.
 *
 * This mirrors the backend scope `counts_towards_limit` in Kb::KnowledgeBase.
 */
export const selectKnowledgeBaseCountForBilling = createSelector(
  selectKnowledgeBases,
  selectIsKbsLoaded,
  (kbs, isKbsLoaded) => {
    if (!isKbsLoaded) return null
    return kbs.filter(kb => kb.migrationStatus !== 'completed').length
  }
)
